import { TileLayer } from '@deck.gl/geo-layers';
import { PolygonLayer } from 'deck.gl';

export const berthLayer = (berths: any) => {
  if (!berths.display || !berths.data.length) return null;

  return new TileLayer({
    id: 'berth-tile-layer',
    minZoom: 10,
    maxZoom: 100,
    tileSize: 1024,

    getTileData: (tile: any) => {
      // Placeholder: Implement data fetching logic for each tile
      // This function should return a promise that resolves with the data for the tile
      // For now, we pass all data. Implement filtering by tile.bbox for optimization.
      return Promise.resolve(
        berths.data.filter((d: any) => {
          // Basic bounding box check (simplified)
          // This needs to be adapted to your data's coordinate system and structure
          if (d.geojson && d.geojson.coordinates && d.geojson.coordinates[0]) {
            const firstCoord = d.geojson.coordinates[0][0];
            // Ensure firstCoord is an array of numbers [longitude, latitude]
            if (
              Array.isArray(firstCoord) &&
              firstCoord.length === 2 &&
              typeof firstCoord[0] === 'number' &&
              typeof firstCoord[1] === 'number'
            ) {
              const [longitude, latitude] = firstCoord;
              return (
                longitude >= tile.bbox.west &&
                longitude <= tile.bbox.east &&
                latitude >= tile.bbox.south &&
                latitude <= tile.bbox.north
              );
            }
          }
          return false;
        }),
      );
    },

    renderSubLayers: (props: any) => {
      const tileData = props.data;
      if (!tileData || tileData.length === 0) {
        return null;
      }

      return new PolygonLayer({
        id: `${props.id}-polygon-layer`, // Unique ID for sublayer
        data: tileData, // Use tile-specific data
        pickable: true,
        stroked: true,
        filled: true,
        wireframe: true,
        lineWidthMinPixels: 1,
        getPolygon: (d: any) => d.geojson.coordinates[0],
        getFillColor: [255, 255, 0, 200],
        getLineColor: [0, 0, 0],
        getLineWidth: 1,
        // Optional: Use updateTriggers if props affecting rendering change
        // updateTriggers: {
        //   getPolygon: [props.tile.id], // Example: re-evaluate getPolygon if tile id changes
        // },
      });
    },
  });
};
